import { useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { updateUserPassword } from '../../actions/users-profile-actions';
import { Box, Divider, Flex, Stack } from "@chakra-ui/react";
import { reloadPage } from '../../../global/helpers/global-helpers';
import LaunchdeckButton from '../../../global/components/helper-components/components/LaunchdeckButton';
import LaunchdeckModal from '../../../global/components/helper-components/components/LaunchdeckModal';
import LaunchdeckFormInput from '../../../forms/TextInputField/components/LaunchdeckFormInput';
import { MdPublishedWithChanges } from 'react-icons/md';


function UserChangePasswordModule({ updatePasswordOutcome, passwordIsUpdating, updateUserPassword }) {

	const minPasswordLength = 6;
	const { passwordUpdateStatus } = updatePasswordOutcome || {};

	const [newPasswordInput, setNewPasswordInput] = useState('');
	const [newPasswordConfirmationInput, setNewPasswordConfirmationInput] = useState('');
	const [currentPasswordInput, setCurrentPasswordInput] = useState('');

	const [emptyPasswordError, setEmptyPasswordError] = useState(false);
	const [displayConfirmationError, setDisplayConfirmationError] = useState(false);
	const [displayShortPasswordError, setDisplayShortPasswordError] = useState(false);

	const sameInputs = (newPasswordInput.length > 5 && newPasswordInput === newPasswordConfirmationInput) ? true : false;

	const isWrongPassword = (passwordUpdateStatus === 'wrong-password') ? true : "";
	const passwordChangeSuccessful = (passwordUpdateStatus === 'password-changed') ? true : "";

	const [showModal, setShowModal] = useState(null)

	const handleCloseModal = () => {
		setShowModal(false)
	}

	function handleSetNewPassword() {

		if (!currentPasswordInput) {
			setEmptyPasswordError(true)
		} else setEmptyPasswordError(false)

		if (newPasswordInput.length <= minPasswordLength) {
			setDisplayShortPasswordError(true)
		} else setDisplayShortPasswordError(false)

		if (!sameInputs && newPasswordInput.length > minPasswordLength) {
			setDisplayConfirmationError(true)
		} else setDisplayConfirmationError(false)

		if (sameInputs) {
			updateUserPassword(currentPasswordInput, newPasswordInput)
		}
	}

	function handleChange(event) {
		const value = event.target.value;

		switch (event.target.name) {
			case ('currentPassword'): {
				setCurrentPasswordInput(value)
				break;
			}
			case ('inputPassword'): {
				setNewPasswordInput(value)
				break;
			}
			case ('repeatPassword'): {
				setNewPasswordConfirmationInput(value)
				break;
			}
			default: break;
		}

	}

	return (
		<Box>
			<Flex justify='space-between' align='center'>
				<Box>
					<Box className="user-profile-section__first-label"> Change password </Box>
					<Box color='gray.500' maxWidth='500px' fontSize='0.8em' mt='-0.5em'>Set a new password for your account </Box>
				</Box>
				<LaunchdeckButton bg='brandDark.500' color='white' px='3em' onClick={() => setShowModal(!showModal)} label='Change' />
			</Flex>

			<LaunchdeckModal
				title='Change password'
				handleCloseModal={handleCloseModal}
				showModal={showModal}
				maxW='35em'
			>
				{
					passwordChangeSuccessful ?
						<>
							<Flex direction='column' align='center' m='2em' gap='0.5em'>

								<Box as={MdPublishedWithChanges} boxSize='2em' color='brandGreen.500' />
								<Box fontSize='0.875em'>
									Password successfully changed
								</Box>

								<Flex mt='2em'>
									<LaunchdeckButton bg='brandDark.500' color='white' px='3em' onClick={() => reloadPage()} label='Back' />
								</Flex>
							</Flex>
						</>
						:
						<>
							<Flex align='center' w='100%' direction='column'>
								<Stack w='100%' maxW={['inherit', '35em']} px={['1.5em', '2em']} py='1em' overflowY='auto' maxHeight='75vh'>

									<Box className='section-header-label' color='brandPink.500' mb='0.5em' fontSize={['0.8em', '0.875em']}>Current</Box>
									<LaunchdeckFormInput
										label='Current Password'
										name={'currentPassword'}
										onChange={handleChange}
										value={currentPasswordInput}
										isRequired={true}
										type="password"

										errorLogic={isWrongPassword || emptyPasswordError}
										errorMessage={isWrongPassword ? "Your password is incorrect. Please try again" : "Please enter your CURRENT password"}
									/>

									<Divider my='0.5em' />

									<Box className='section-header-label' color='brand.500' mb='0.5em' fontSize={['0.8em', '0.875em']}>New</Box>
									<LaunchdeckFormInput
										label='Your preferred new password'
										name={'inputPassword'}
										onChange={handleChange}
										value={newPasswordInput}
										isRequired={true}
										type="password"

										errorLogic={displayShortPasswordError}
										errorMessage={`Your password must contain more than ${minPasswordLength} characters.`}
									/>


									<LaunchdeckFormInput
										label='Confirm your new password'
										name={'repeatPassword'}
										onChange={handleChange}
										value={newPasswordConfirmationInput}
										isRequired={true}
										type="password"

										errorLogic={displayConfirmationError}
										errorMessage={`Your new & confirmation passwords don't match`}
									/>
								</Stack>
							</Flex>

							<Flex w='100%' p={['1em 2em 1em 2em', '2em']} maxW={['inherit', '35em']}>
								<Flex justify='center' w='100%'>
									<LaunchdeckButton bg='brand.500' color='gray.50' w='100%' label='Set new password' loadingLogic={passwordIsUpdating} onClick={handleSetNewPassword} />
								</Flex>
							</Flex>
						</>
				}

			</LaunchdeckModal>
		</Box>


	)


}


function mapStateToProps(state) {
	return {
		updatePasswordOutcome: state.updatePassword.results.data,
		passwordIsUpdating: state.updatePassword.isLoading
	};
}

const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			updateUserPassword
		},
		dispatch,
	)


export default connect(mapStateToProps, mapDispatchToProps)(UserChangePasswordModule);
